import React, {useState} from "react";
import {CommonStepProps} from "./DynamicStepComponentRenderer";
import {Button} from "react-bootstrap";
import ConfirmModal from "../../modals/ConfirmModal";
import {useTranslation} from "react-i18next";
import {useStepFunctions} from "../../../api/steps/useStepFunctions";
import notifier from "simple-react-notifications2";


export function Execute(props: CommonStepProps) {
    const {t, i18n} = useTranslation();
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDeclineModal, setShowDeclineModal] = useState(false)
    const {loading, error, execute, accept, decline} = useStepFunctions();

    function executeClicked() {
        setShowConfirmModal(true)
    }

    function executeConfirm() {
        execute(props.orderId, props.step.status?.id!!).then(res => {
            notifier.success("Success")
            props.reload()
        })
    }

    return (
        <>
            <Button disabled={loading} variant="primary" onClick={() => executeClicked()}>
                {"Execute"}
            </Button>
            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onConfirm={executeConfirm}
                title={"Execute step"}
                body={"Execute step"}
            />
        </>
    )
}